module.exports = (__webpack_public_path__ || '') + "static/images/maskot-315347a947af1447846a88551ee27bf3.png";